module.exports = __webpack_public_path__ + "static/media/eveslash.44821191.png";